/**
 * Develop. The only deployed environment for now — staging and production come
 * later, deliberately (see the backoffice plan §8).
 *
 * `googleClientId` is public by design: this app uses the ID-token flow, which
 * has no client secret at any point.
 */
export const environment = {
  production: false,
  apiUrl: 'https://api.develop.zelo.no',
  googleClientId:
    '575005212950-r7fqi5r3sjdo87osquehridnntkm4vsd.apps.googleusercontent.com',
  googleHostedDomain: 'zeloapp.com'
};
